module.exports = __webpack_public_path__ + "assets/img/reserve-type-icon2.86ee70b9.png";